<template>
  <layout name="LayoutDefault">
    <div class="fb-page">
      <div class="container">
        <div class="fb-card">

          <!-- Header -->
          <div class="fb-hero">
            <div class="fb-hero__badge">কথাপ্রকাশ</div>
            <h1 class="fb-hero__title">সার্ভিস ফিডব্যাক</h1>
            <p class="fb-hero__desc">
              কথাপ্রকাশে আমাদের দায়িত্ব শুধু বই প্রকাশের মধ্যেই সীমাবদ্ধ নয় — পাঠকের কাছে বই পৌঁছানোর
              প্রতিটি ধাপে আমরা যত্নশীল। আপনার মূল্যবান মতামত আমাদের সেবার মান উন্নত করতে সাহায্য করবে।
            </p>
          </div>

          <form class="fb-body" @submit.prevent="submitFeedback">

            <!-- Name + Mobile -->
            <div class="fb-grid">
              <div class="fb-field">
                <label class="fb-label" for="fbName">আপনার নাম <span class="fb-req">*</span></label>
                <input type="text" class="fb-input" id="fbName" v-model="name"
                  placeholder="আপনার নাম লিখুন" autocomplete="off" />
              </div>
              <div class="fb-field">
                <label class="fb-label" for="fbMobile">
                  মোবাইল নাম্বার <span class="fb-req">*</span>
                </label>
                <input type="tel" class="fb-input" id="fbMobile" v-model="mobile" maxlength="11"
                  inputmode="numeric" placeholder="01XXXXXXXXX" autocomplete="off"
                  @input="mobile = mobile.replace(/[^0-9]/g, '')" />
              </div>
            </div>

            <!-- Rating questions -->
            <div class="fb-question" v-for="(q, qi) in ratingQuestions" :key="q.model">
              <div class="fb-q-head">
                <span class="fb-q-num">{{ qi + 1 }}</span>
                <span class="fb-q-text">{{ q.label }}</span>
              </div>
              <div class="fb-stars"
                @mouseleave="hover[q.model] = 0">
                <button type="button" class="fb-star"
                  v-for="n in 5" :key="n"
                  :class="{ 'is-on': n <= (hover[q.model] || form[q.model]) }"
                  @mouseenter="hover[q.model] = n"
                  @click="form[q.model] = n"
                  :aria-label="n + ' star'">
                  <i class="fa fa-star"></i>
                </button>
                <span class="fb-star-label" :class="{ 'is-set': form[q.model] }">
                  {{ ratingLabel(q, hover[q.model] || form[q.model]) }}
                </span>
              </div>
            </div>

            <!-- Recommend -->
            <div class="fb-question">
              <div class="fb-q-head">
                <span class="fb-q-num">5</span>
                <span class="fb-q-text">পরবর্তীতে বই সংগ্রহ এবং অন্যকে পরামর্শ দেয়ার ক্ষেত্রে ‘কথাপ্রকাশ’ কে গুরুত্ব দিবেন কিনা?</span>
              </div>
              <div class="fb-chips">
                <button type="button" class="fb-chip"
                  v-for="opt in recommendOptions" :key="opt.v"
                  :class="{ 'is-active': recommend === opt.v }"
                  @click="recommend = opt.v">
                  {{ opt.l }}
                </button>
              </div>
            </div>

            <!-- Source -->
            <div class="fb-question">
              <div class="fb-q-head">
                <span class="fb-q-num">6</span>
                <span class="fb-q-text">এই বই/বইগুলো সম্পর্কে আপনি প্রথম কোথা থেকে জেনেছেন?</span>
              </div>
              <div class="fb-chips">
                <button type="button" class="fb-chip"
                  v-for="opt in sourceOptions" :key="opt.v"
                  :class="{ 'is-active': source === opt.v }"
                  @click="source = opt.v">
                  {{ opt.l }}
                </button>
              </div>
            </div>

            <!-- Suggestion -->
            <div class="fb-question">
              <div class="fb-q-head">
                <span class="fb-q-num">7</span>
                <span class="fb-q-text">বইয়ের মান, অনলাইন সার্ভিস কিংবা অন্য বিষয়ে আপনার পরামর্শ</span>
              </div>
              <textarea class="fb-input fb-textarea" rows="4" v-model="suggestion"
                placeholder="আপনার পরামর্শ লিখুন..." autocomplete="off"></textarea>
            </div>

            <button type="submit" class="fb-submit" :disabled="submitting">
              <span v-if="!submitting">মতামত জমা দিন</span>
              <span v-else>পাঠানো হচ্ছে...</span>
            </button>

          </form>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Feedback`,
  components: {
    Layout,
  },
  data() {
    return {
      name: null,
      mobile: "",
      recommend: null,
      source: null,
      suggestion: null,
      submitting: false,
      form: {
        rating_service: null,
        rating_delivery: null,
        rating_quality: null,
        rating_value: null,
      },
      hover: {
        rating_service: 0,
        rating_delivery: 0,
        rating_quality: 0,
        rating_value: 0,
      },
      ratingQuestions: [
        {
          model: "rating_service",
          label: "সর্বশেষ অর্ডারের সার্ভিস সর্বোপরি আপনার কাছে কেমন ছিল?",
          labels: { 5: "Very Satisfied", 4: "Satisfied", 3: "Average", 2: "Below Average", 1: "Very Dissatisfied" },
        },
        {
          model: "rating_delivery",
          label: "বইয়ের ডেলিভারি সময়কাল কেমন ছিল?",
          labels: { 5: "Very Fast", 4: "Fast", 3: "Average", 2: "Slow", 1: "Very Slow" },
        },
        {
          model: "rating_quality",
          label: "আপনার সংগৃহীত বইয়ের মান কেমন ছিল?",
          labels: { 5: "As Expected", 4: "Good Enough", 3: "Average", 2: "Below Expectation", 1: "Bad" },
        },
        {
          model: "rating_value",
          label: "বইয়ের মূল্য অনুযায়ী বইয়ের মান কেমন ছিল?",
          labels: { 5: "Perfect", 4: "Good Pricing", 3: "Average", 2: "Below Average", 1: "Very Low" },
        },
      ],
      recommendOptions: [
        { v: "yes", l: "হ্যাঁ, অবশ্যই" },
        { v: "unsure", l: "নিশ্চিত নই" },
        { v: "no", l: "অবশ্যই না" },
      ],
      sourceOptions: [
        { v: "fb_ad", l: "ফেসবুক বিজ্ঞাপন / পোস্ট" },
        { v: "fb_page", l: "কথাপ্রকাশের ফেসবুক পেজ" },
        { v: "magazine", l: "পত্রিকা" },
        { v: "author", l: "লেখক" },
        { v: "influencer", l: "বুক ইনফ্লুয়েন্সার / রিভিউয়ার" },
        { v: "friends", l: "বন্ধুবান্ধব / পরিচিতজন" },
      ],
    };
  },
  mounted() {
    // Prefill name + mobile for a logged-in customer. Never forces login.
    if (localStorage.getItem("token")) {
      const savedName = localStorage.getItem("name");
      const savedMobile = localStorage.getItem("mobile");
      if (savedName && savedName !== "undefined") this.name = savedName;
      if (savedMobile && savedMobile !== "undefined") this.mobile = savedMobile;
    }
  },
  methods: {
    ratingLabel(q, value) {
      return value ? q.labels[value] : "";
    },
    submitFeedback() {
      if (!this.name || !this.name.trim()) {
        this.flashMessage.error({
          message: "আপনার নাম লিখুন।",
        });
        return;
      }

      if (!/^01[3-9]\d{8}$/.test(this.mobile)) {
        this.flashMessage.error({
          message: "সঠিক ১১-সংখ্যার মোবাইল নাম্বার দিন (যেমন 01XXXXXXXXX)।",
        });
        return;
      }

      this.submitting = true;

      const payload = {
        name: this.name,
        mobile: this.mobile,
        rating_service: this.form.rating_service,
        rating_delivery: this.form.rating_delivery,
        rating_quality: this.form.rating_quality,
        rating_value: this.form.rating_value,
        recommend: this.recommend,
        source: this.source,
        suggestion: this.suggestion,
      };

      this.$http
        .post("feedback/store", payload)
        .then((response) => {
          if (response.data.status) {
            this.flashMessage.success({
              message: "আপনার মূল্যবান মতামতের জন্য ধন্যবাদ।",
            });
            this.resetForm();
          } else {
            this.flashMessage.error({
              message: "দুঃখিত, কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
            });
          }
        })
        .catch(() => {
          this.flashMessage.error({
            message: "দুঃখিত, কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    resetForm() {
      this.name = null;
      this.mobile = "";
      this.recommend = null;
      this.source = null;
      this.suggestion = null;
      this.form.rating_service = null;
      this.form.rating_delivery = null;
      this.form.rating_quality = null;
      this.form.rating_value = null;
    },
  },
};
</script>

<style scoped>
.fb-page {
  --fb-brand: #aa4242;
  --fb-brand-dark: #8a3535;
  --fb-ink: #2b2b2b;
  --fb-muted: #8a8a8a;
  --fb-line: #ececec;
  background: linear-gradient(180deg, #faf7f6 0%, #f3eeec 100%);
  padding: 40px 0 64px;
}

.fb-card {
  max-width: 760px;
  margin: 0 auto;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 18px 50px rgba(120, 60, 60, 0.10), 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* Hero */
.fb-hero {
  position: relative;
  padding: 44px 40px 36px;
  text-align: center;
  color: #fff;
  background: linear-gradient(135deg, #aa4242 0%, #c96a6a 100%);
}
.fb-hero__badge {
  display: inline-block;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 5px 14px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  margin-bottom: 14px;
}
.fb-hero__title {
  font-size: 30px;
  font-weight: 800;
  margin: 0 0 12px;
  color: #fff;
}
.fb-hero__desc {
  max-width: 540px;
  margin: 0 auto;
  font-size: 14.5px;
  line-height: 1.7;
  opacity: 0.95;
}

/* Body */
.fb-body {
  padding: 34px 40px 40px;
}
.fb-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 28px;
}
.fb-field { display: flex; flex-direction: column; }
.fb-label {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--fb-ink);
  margin-bottom: 8px;
}
.fb-req { color: var(--fb-brand); }

.fb-input {
  width: 100%;
  border: 1.5px solid var(--fb-line);
  border-radius: 12px;
  padding: 12px 15px;
  font-size: 15px;
  color: var(--fb-ink);
  background: #fbfafa;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.fb-input::placeholder { color: #b9b4b2; }
.fb-input:focus {
  outline: none;
  border-color: var(--fb-brand);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(170, 66, 66, 0.10);
}
.fb-textarea { resize: vertical; min-height: 110px; line-height: 1.6; }

/* Questions */
.fb-question {
  padding: 22px 0;
  border-top: 1px solid var(--fb-line);
}
.fb-q-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}
.fb-q-num {
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: rgba(170, 66, 66, 0.10);
  color: var(--fb-brand);
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}
.fb-q-text {
  font-size: 15.5px;
  font-weight: 600;
  color: var(--fb-ink);
  line-height: 1.55;
}

/* Stars */
.fb-stars {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 38px;
}
.fb-star {
  background: none;
  border: none;
  padding: 2px;
  font-size: 27px;
  line-height: 1;
  color: #dcdcdc;
  cursor: pointer;
  transition: transform 0.12s, color 0.12s;
}
.fb-star:hover { transform: scale(1.15); }
.fb-star.is-on { color: #f5b301; }
.fb-star-label {
  margin-left: 12px;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--fb-muted);
  min-height: 18px;
}
.fb-star-label.is-set { color: var(--fb-brand); }

/* Chips */
.fb-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-left: 38px;
}
.fb-chip {
  background: #fbfafa;
  border: 1.5px solid var(--fb-line);
  border-radius: 999px;
  padding: 9px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  cursor: pointer;
  transition: all 0.16s;
}
.fb-chip:hover { border-color: #d6a3a3; color: var(--fb-brand); }
.fb-chip.is-active {
  background: var(--fb-brand);
  border-color: var(--fb-brand);
  color: #fff;
  box-shadow: 0 6px 16px rgba(170, 66, 66, 0.28);
}

/* Submit */
.fb-submit {
  width: 100%;
  margin-top: 30px;
  border: none;
  border-radius: 14px;
  padding: 16px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(135deg, #aa4242 0%, #c96a6a 100%);
  box-shadow: 0 10px 24px rgba(170, 66, 66, 0.30);
  transition: transform 0.14s, box-shadow 0.14s, opacity 0.14s;
}
.fb-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(170, 66, 66, 0.38);
}
.fb-submit:disabled { opacity: 0.65; cursor: not-allowed; }

/* Responsive */
@media (max-width: 767px) {
  /* Clear the site's fixed mobile header (matches .contents margin-top) */
  .fb-page { padding: 20px 0 40px; margin-top: 110px; }
  .fb-card { border-radius: 16px; }
  .fb-hero { padding: 34px 22px 28px; }
  .fb-hero__title { font-size: 24px; }
  .fb-body { padding: 24px 20px 30px; }
  .fb-grid { grid-template-columns: 1fr; gap: 16px; margin-bottom: 20px; }
  .fb-stars, .fb-chips { padding-left: 0; }
  .fb-q-text { font-size: 14.5px; }
  .fb-star { font-size: 24px; }
  .fb-star-label { flex-basis: 100%; margin-left: 0; margin-top: 6px; }
}
</style>
